import React, { useState, useEffect, useRef } from "react"

import { Icon } from "../Icon/Icon"
import { InfoWindow, InfoInner, Title, Text, Space, Content, ContentHours, StyledIconWrapper } from "./MapStyles"
import { RichText } from "../RichText/RichText"

const MapMarker = ({ store, onClose, disableInfoWindow }) => {
  const markerRef = useRef(null)
  const [clientHeight, setClientHeight] = useState(0)

  useEffect(() => {
    if (markerRef?.current?.clientHeight && store.showInfoWindow) {
      setClientHeight(markerRef?.current?.clientHeight)
    }
  }, [store.showInfoWindow])

  return (
    <>
      <Icon name={`marker`} size={`small`} />
      {store.showInfoWindow && !disableInfoWindow && (
        <InfoWindow ref={markerRef} height={clientHeight}>
          <InfoInner>
            <StyledIconWrapper onClick={() => onClose(store.id)}>
              <Icon name={`cross`} size={`small`} />
            </StyledIconWrapper>
            <Title>{store.title}</Title>
            <Content>
              <Space />
              <RichText>{store?.description}</RichText>
              {store?.description?.length > 0 ? <Space /> : null}
              {store?.openhours?.length > 0 && <Text bold={"true"}>Normal Trading Hours</Text>}
              {store?.openhours?.map((item, index) => (
                <ContentHours key={index}>
                  <Text>{`${item.day}:`}</Text>
                  <Text>{item.hours}</Text>
                </ContentHours>
              ))}
              <Space />
            </Content>

            <Content>
              <RichText>{store.addressRich}</RichText>
              <Space />
              <Text hover={"true"}>
                <a href={`tel:${store.phone}`} target="_blank" rel="noreferrer">
                  {store.phone}
                </a>
              </Text>
              <Text full={"true"} hover={"true"}>
                <a href={`mailto:${store.email}`} target="_blank" rel="noreferrer">
                  {store.email}
                </a>
              </Text>
            </Content>
          </InfoInner>
        </InfoWindow>
      )}
    </>
  )
}

export default MapMarker
